module.exports = __webpack_public_path__ + "src/assets/hero-dragon-100.jpg";